<div
  class="filter-item"
  [ngClass]="{ active: isActive || isOpen }"
  (click)="toggleOpen()"
>
  <span>All filters</span>
  <app-shared-icon name="filter-outline"></app-shared-icon>
</div>

<app-shared-modal
  name="All filters"
  [open]="isOpen"
  (modalClose)="handleCloseModal()"
>
  <div class="filter-more-content">
    <div class="mb-6">
      <app-filter-v2-status [mobile]="true"></app-filter-v2-status>
    </div>
    <!-- <app-filter-v2-financials [mobile]="true"></app-filter-v2-financials> -->
    <div class="mb-2">
      <app-filter-v2-price [mobile]="true"></app-filter-v2-price>
    </div>
    <div class="mb-2">
      <app-filter-v2-subtype [mobile]="true"></app-filter-v2-subtype>
    </div>
    <app-filter-v2-beds></app-filter-v2-beds>
    <app-filter-v2-baths></app-filter-v2-baths>
    <app-filter-v2-sqft></app-filter-v2-sqft>
    <app-filter-v2-lot-size></app-filter-v2-lot-size>
    <app-filter-v2-year-built></app-filter-v2-year-built>
  </div>

  <app-filter-v2-buttons
    [mobile]="true"
    (resetAction)="handleReset()"
    (applyAction)="handleApply()"
  ></app-filter-v2-buttons>
</app-shared-modal>
